<template>
  <div id="complete">
    <CommonHeader />

    <div class="infoColumn">会員登録が完了しました</div>
    <div class="body"
      >この度はUPLUSに会員登録いただき誠にありがとうございます。<br />
      会員登録完了後30分以内にメールを送らせていただきます。<br />
      この後の案内などは届いたメールに記載してありますので、ご確認お願いいたします。<br />
      <br />
      メールが届かない場合は「info@u-plus.jp」までご連絡ください。
    </div>

    <a href="https://u-plus.jp/">ホームページへ戻る</a>
  </div>
</template>

<script>
import CommonHeader from '@components/organisms/common_header.vue'

export default {
  components: {
    CommonHeader,
  },
  data() {
    return {}
  },
  mounted: function() {},
}
</script>

<style lang="scss" scoped>
@import '../../design/common-settings';
.infoColumn {
  height: 40px;
  margin: 0;
  line-height: 40px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}

.body {
  margin: 10px 10px;
  line-height: 25px;
  text-align: left;
}

.inputInfo {
  width: 80%;
  margin: 10px 10px;
  &Select {
    margin: 10px 10px;
  }
}

.button {
  margin-bottom: 20px;
  &Cheer {
    margin-bottom: 20px;
    background-color: $like-color;
  }
}
</style>
